import { ColumnPattern } from '@/common/components/Table'

export const pendingColumns: ColumnPattern[] = [
  { label: 'Nome do Modelo na infocar', value: 'display_name' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
]

export const homologatedColumns: ColumnPattern[] = [
  { label: 'Nome do Modelo', value: 'display_name' },
  { label: 'Status', value: 'status' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
]
